import React from "react";
import { Layout} from "antd";
import HeaderNavigationContainer from "../components/HeaderNavigation/container";
import FooterContainer from "../components/Footer/container";
import ContactForm from "../components/ContactForm";
import {getBackgroundImage} from "../infrastructure/helpers/getBackgroundImage"

const { Header, Content } = Layout;

function Contact(props) {
  return (
    <Layout
      className="layout homebg"
      style={{
        background: `url(${getBackgroundImage('front')}) no-repeat black`,
        backgroundSize: "100%"
      }}
    >
      <HeaderNavigationContainer />
      <Header className="">
        <div
          style={{
            color: "#fff",
            position: "relative",
            width: "100%",
            bottom: 0,
            marginTop: "20%"
          }}
        >
          <div>
            <button
              onClick={() => window.scrollBy(0, 700)}
              className="arrow_button"
            >
              <i className="arrow arrow_down" />
            </button>
          </div>
        </div>
      </Header>
      <Content>
        <div style={{ padding: "50px 0" }}>
          <ContactForm />
        </div>
      </Content>
      <FooterContainer />
    </Layout>
  );
}
export default Contact;



// WEBPACK FOOTER //
// ./src/pages/Contact.js